export const SAVE_USER = 'SAVE_USER';
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const IS_NOT_MODERATOR = 'IS_NOT_MODERATOR';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const AUTHENTICATE = 'AUTHENTICATE';
export const UNAUTHENTICATE = 'UNAUTHENTICATE';
export const REDIRECTED = 'REDIRECTED';
export const SAVE_COMPANY_SUMMARY = 'SAVE_COMPANY_SUMMARY';
export const SAVE_COMPANY_NEWS = 'SAVE_COMPANY_NEWS';
export const SAVE_COMPANY_NEWS_PAGE = 'SAVE_COMPANY_NEWS_PAGE';
export const HIDE_CINTEL = 'HIDE_CINTEL';
export const SHOW_INV_MODAL = 'SHOW_INV_MODAL';
export const HIDE_INV_MODAL = 'HIDE_INV_MODAL';
export const SHOW_PARTICIPANT_ERROR_MODAL = 'SHOW_PARTICIPANT_ERROR_MODAL';
export const HIDE_PARTICIPANT_ERROR_MODAL = 'HIDE_PARTICIPANT_ERROR_MODAL';
export const SAVE_PARTICIPANT_CREDS = 'SAVE_PARTICIPANT_CREDS';
export const OPEN_CINTEL = 'OPEN_CINTEL';
export const CLOSE_CINTEL = 'ClOSE_CINTEL';
export const OPEN_ISSUE_POPUP = 'OPEN_ISSUE_POPUP';
export const CLOSE_ISSUE_POPUP = 'CLOSE_ISSUE_POPUP';
export const STOP_RECORDING = 'STOP_RECORDING';
export const START_RECORDING = 'START_RECORDING';
export const UPDATE_CINTEL = 'UPDATE_CINTEL';
export const SHOW_STOP_REC_MODAL = 'SHOW_STOP_REC_MODAL';
export const HIDE_STOP_REC_MODAL = 'HIDE_STOP_REC_MODAL';
export const SAVE_ROOM_DETAILS = 'SAVE_ROOM_DETAILS';
export const EMBED_TYPE = 'EMBED_TYPE';
export const SAVE_CUSTOMER = 'SAVE_CUSTOMER';
export const SAVE_VIDEO_DOMAIN = 'SAVE_VIDEO_DOMAIN';
export const SAVE_ROOM_META = 'SAVE_ROOM_META';
export const CLICKED_START_RECORDING = 'CLICKED_START_RECORDING';
